import { z } from "zod";

// --- PURCHASE REQUEST (PR) ---
export const purchaseRequestSchema = z.object({
    material_id: z.string().min(1, "Vui lòng chọn vật tư"),
    material_plan_id: z.string().optional(),
    material_name: z.string().optional(),
    quantity: z.coerce.number({ invalid_type_error: "Số lượng phải là số" }).min(1, "Số lượng phải lớn hơn 0"),
    unit: z.string().optional(),
    required_date: z.string().optional(),
    supplier_id: z.string().optional(),
    reason: z.string().optional(),
    status: z.enum(["pending", "approved", "ordered", "rejected"]).default("pending"),
});


// --- USER ---
export const userSchema = z.object({
    user_id: z.string().optional(),
    full_name: z.string().min(2, "Họ tên phải có ít nhất 2 ký tự"),
    email: z.string().email("Email không hợp lệ"),
    role: z.string().min(1, "Vui lòng chọn vai trò"),
    department: z.string().min(1, "Vui lòng chọn phòng ban"),
    section: z.string().optional(),
    position: z.string().min(1, "Vui lòng chọn chức vụ"),
    phone: z.string().regex(/(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/, "Số điện thoại không hợp lệ").optional().or(z.literal("")),
    status: z.enum(["ACTIVE", "INACTIVE", "SUSPENDED"]).default("ACTIVE"),
    password: z.string().optional(),
    avatar: z.string().optional(),
    signature: z.string().optional(),
    // HRM Fields
    gender: z.string().optional(),
    dateOfBirth: z.string().optional().or(z.literal("")),
    idCardNumber: z.string().optional(),
    idCardIssueDate: z.string().optional().or(z.literal("")),
    idCardIssuePlace: z.string().optional(),
    taxNumber: z.string().optional(),
    socialInsuranceNumber: z.string().optional(),
    joinDate: z.string().optional().or(z.literal("")),
    officialDate: z.string().optional().or(z.literal("")),
    emergencyContact: z.string().optional(),
    bankName: z.string().optional(),
    bankAccountNumber: z.string().optional(),
    bankBranch: z.string().optional(),
    educationLevel: z.string().optional(),
    contractStatus: z.string().optional(),
});

// --- ROLE ---
export const roleSchema = z.object({
    id: z.string().optional(),
    roleId: z.string().min(1, "Mã Role là bắt buộc"),
    name: z.string().min(1, "Tên Role là bắt buộc"),
    description: z.string().optional(),
    permissions: z.record(z.any()).optional().default({}),
});

// --- MACHINE ---
export const machineSchema = z.object({
    id: z.string().optional(),
    machineId: z.string().min(1, "Mã thiết bị là bắt buộc"),
    name: z.string().min(1, "Tên thiết bị là bắt buộc"),
    type: z.string().min(1, "Loại thiết bị là bắt buộc"),
    processCategory: z.string().optional(),
    
    // 1. ẢNH VÀ THÔNG TIN CHUNG
    imageUrl: z.string().optional(),
    manufacturer: z.string().optional(),
    countryOfOrigin: z.string().optional(),
    yearManufactured: z.string().optional(),
    serialNumber: z.string().optional(),

    // 2. NĂNG LỰC KỸ THUẬT
    workingFormat: z.string().optional(),
    /** Khổ kẽm CTP của máy in (mỗi máy 1 khổ) */
    plateSize: z.string().optional().nullable(),
    paperWeightRange: z.string().optional(),
    powerConsumptionKw: z.coerce.number().optional().nullable(),
    technicalModel: z.string().optional(),
    
    technicalSpecs: z.record(z.string(), z.any()).optional().nullable(),
    
    standardProductivity: z.coerce.number().optional().nullable(),
    setupTimeMinutes: z.coerce.number().optional().nullable(),
    hourlyRate: z.coerce.number().optional().nullable(),
    costPerHour: z.coerce.number().optional().nullable(),

    // 3. QUẢN TRỊ VẬN HÀNH & CMMS
    status: z.string().default("IDLE"),
    totalRunningHours: z.coerce.number().optional().nullable(),
    totalOutputQuantity: z.coerce.number().optional().nullable(),

    maintenanceCycleHours: z.coerce.number().optional().nullable(),
    maintenanceCycleDays: z.coerce.number().optional().nullable(),
    nextMaintenanceDate: z.string().optional().nullable().or(z.literal("")),
    nextMaintenanceHours: z.coerce.number().optional().nullable(),
});
